import styled, { css } from 'styled-components';
import { unit, marginTop, pxToRem } from '../v2/foundation/spacing/utils.js';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { interactiveTransition } from '../v2/foundation/theme/utils.js';
import { formLabel } from '../theme/typography/styles.js';

var containerSize = {
  small: 4,
  large: 6
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-k0tz7j-0"
})(["display:grid;grid-template-columns:", " auto;gap:", ";"], function (props) {
  return unit(containerSize[props.$size]);
}, unit(1));
var InputContainer = styled.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-k0tz7j-1"
})(["display:inline-block;position:relative;width:", ";height:", ";", ";"], function (props) {
  return unit(containerSize[props.$size]);
}, function (props) {
  return unit(containerSize[props.$size]);
}, function (props) {
  return props.$hasLabel && props.$size === 'small' && marginTop(1);
});
var Overlay = styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-k0tz7j-2"
})(["display:flex;align-items:center;justify-content:center;position:absolute;pointer-events:none;top:0;right:0;bottom:0;left:0;border:", " solid ", ";& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " transparent;", ";"], pxToRem(1), themeGet('colors.border.200'), themeGet('colors.primary.0'), themeGet('colors.primary.0'), function (props) {
  return props.$invalid && themeGet('colors.red.500');
}, unit(0.5), interactiveTransition);
var checkedStyles = css(["&:checked + div{& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " transparent;}"], themeGet('colors.primary.0'), function (props) {
  return props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000');
}, function (props) {
  return props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.800');
}, unit(0.5));
var indeterminateStyles = css(["&:indeterminate:not([type='radio'],:disabled) + div{& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " transparent;}"], themeGet('colors.primary.0'), function (props) {
  return props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000');
}, function (props) {
  return props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.800');
}, unit(0.5));
var hoverStyles = css(["&:not(:disabled):hover + div{filter:brightness(0.9);}"]);
var focusStyles = css(["&:not(:disabled):focus-visible + div{& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " ", ";}&:not(:disabled):focus-visible:checked + div{background-color:", ";}"], themeGet('colors.primary.0'), themeGet('colors.primary.0'), function (props) {
  return props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.600');
}, unit(0.5), themeGet('colors.focus.primary'), function (props) {
  return props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000');
});
var activeStyles = css(["&:not(:disabled):active + div{& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " transparent;}"], themeGet('colors.primary.800'), themeGet('colors.primary.50'), themeGet('colors.primary.1000'), unit(0.5));
var disabledStyles = css(["&:disabled + div{& svg{color:", ";}background-color:", ";border-color:", ";box-shadow:0 0 0 ", " transparent;}&:disabled:checked + div{& svg{color:", ";}}"], themeGet('colors.disabled.100'), themeGet('colors.disabled.100'), themeGet('colors.disabled.200'), unit(0.5), themeGet('colors.disabled.200'));
var Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-k0tz7j-3"
})(["position:absolute;margin:0;width:100%;height:100%;border:0;-webkit-appearance:none;opacity:0;:focus-visible{outline:none;}", ";", ";", ";", ";", ";", ";"], checkedStyles, indeterminateStyles, hoverStyles, activeStyles, focusStyles, disabledStyles);
var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-k0tz7j-4"
})(["", ";overflow-wrap:break-word;overflow:hidden;"], formLabel);

export { Container, Input, InputContainer, Label, Overlay };
